import { parseISO, isValid, format } from "date-fns"
import i18n from "config/i18n"

function formatDate(
  value?: string,
  formatString = "dd.MM.yyyy",
): string | undefined {
  if (value) {
    const date = parseISO(value)

    if (isValid(date)) {
      return format(date, formatString)
    } else {
      return i18n.t("common.not_available")
    }
  } else {
    return undefined
  }
}

export { formatDate }
